import { LICENSE_STATE_ACTIVE } from '@jira/platform__license-state/src/license-state.tsx';
import { useIsProductUsingCcp } from '@atlassian/jira-billing/src/controllers/billing-system/use-is-product-using-ccp.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getEdition, FREE_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { getApplicationForProject } from '@atlassian/jira-shared-types/src/application.tsx';
import getEditions from '@atlassian/jira-common-util-get-tenant-context/src/edition/index.tsx';
import getLicenseStates from '@atlassian/jira-common-util-get-tenant-context/src/license-state/index.tsx';

import getMeta from '@atlassian/jira-get-meta';

export const useIsEligibleForStorageHardLimitExp = (isProjectAgnostic?: boolean): boolean => {
	const { data: projectContextData } = useProjectContext();
	const appEditions = useAppEditions();

	const shouldIgnoreProjectType = !!isProjectAgnostic;

	// must have JSW installed and be on CCP
	const hasJswOnCcp = useIsProductUsingCcp(SOFTWARE_PROJECT);

	// align with $issueViewAddAttachmentFlag in jira/src/packages/issue/issue-fetch-services-common/src/services/issue-agg-data/utils.tsx
	if (
		!(
			getEditions(getMeta).software === FREE_EDITION &&
			getLicenseStates(getMeta).software === LICENSE_STATE_ACTIVE &&
			fg('jira-storage-hard-limit-gate')
		)
	) {
		return false;
	}

	// default to SOFTWARE_PROJECT if projectType is undefined or shouldIgnoreProjectType is true
	const projectType =
		!shouldIgnoreProjectType && projectContextData?.projectType
			? projectContextData.projectType
			: SOFTWARE_PROJECT;

	// only support if on a jira project, or if shouldIgnoreProjectType is true
	if (!shouldIgnoreProjectType) {
		if (projectType !== SOFTWARE_PROJECT && projectType !== CORE_PROJECT) {
			return false;
		}
	}

	// check that on free edition, projectType defaults to SOFTWARE_PROJECT above
	const application = projectType ? getApplicationForProject(projectType) : null;
	const edition = application ? getEdition(application, appEditions) : null;

	if (edition !== FREE_EDITION) {
		return false;
	}

	// must have JSW on CCP - required for direct buy
	if (!hasJswOnCcp) {
		return false;
	}

	return true;
};
